import { ActionTypes } from "../ActionTypes";
import { GetStorageItem } from "../../helpers/Functions";
import { AuthenticationConstans } from "../../Constants";
import { IState } from "../../components/pages/models/interfaces/IState";

const initialState: IState = {
  activeLink: 0,
  activeFirstLevelSubMenu: 0,
  agents: [],
  identity: GetStorageItem(AuthenticationConstans.Identity)
};

export const LayoutReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case ActionTypes.SET_ACTIVE_LINK:
      return { ...state, activeLink: action.payload };
    case ActionTypes.SET_IDENTITY_NAME:
      return { ...state, identity: action.payload };
    case ActionTypes.SET_FIRST_LEVEL_ACTIVE_MENU:
      return { ...state, activeFirstLevelSubMenu: action.payload };
    case ActionTypes.SET_AGENTS:
      return { ...state, agents: action.payload };
    default:
      return state;
  }
};
